<div class="snackbar-container">
    <span class="snackbar-title-block">{{data.title}}</span>
    <span class="snackbar-action-block">
            <button (click)="close()" class="snackbar-close-button">X</button>
    </span>
    <span class="snackbar-data-block">
        {{data.text}}
    </span>
</div>